var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"perInfo"},[_c('img',{attrs:{"src":_vm.headInfo?.avatar}}),_c('div',[_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.headInfo?.name))]),_c('div',[_vm._v(_vm._s(_vm.headInfo?.mobile))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }